var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-828 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 128,
    height: 128,
    transform: "translate(828 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M113.653,59.882H11.757A11.77,11.77,0,0,0,0,71.639v70.543A11.77,11.77,0,0,0,11.757,153.94h101.9a11.77,11.77,0,0,0,11.757-11.757V71.639A11.77,11.77,0,0,0,113.653,59.882Zm0,7.838a3.9,3.9,0,0,1,1.5.3l-52.45,45.459L10.255,68.024a3.9,3.9,0,0,1,1.5-.3Zm0,78.382H11.757a3.922,3.922,0,0,1-3.919-3.919V76.3l52.3,45.326a3.925,3.925,0,0,0,5.136,0l52.3-45.326v65.878A3.922,3.922,0,0,1,113.653,146.1Z",
    transform: "translate(829.295 485.089)",
    fill: "#98235c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bf7c9297.svg";
export { ForwardRef as ReactComponent };